import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
const WATERMARK_URL = 'https://cdn.magicpatterns.com/uploads/w6KjXSCgaz9Ccg4jbRV1XM/foot-svg.svg';
export function HeroDMRV() {
  return <section className="relative w-full overflow-hidden bg-[#FAFDF7]" data-id="element-962">
      <img src={WATERMARK_URL} alt="" aria-hidden="true" className="absolute pointer-events-none select-none" style={{
      left: '83%',
      top: '75%',
      width: '80%',
      transform: 'translate(-50%, -50%) rotate(10deg)',
      opacity: 0.09
    }} data-id="element-963" />
      <div className="relative z-[2] max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-24 sm:pt-28 sm:pb-32 lg:pt-36 lg:pb-40" data-id="element-964">
        <div className="text-center" data-id="element-965">
          <motion.h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.08]" initial="hidden" animate="visible" variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.12
            }
          }
        }} data-id="element-966">
            <motion.span className="block text-carbon-bright" variants={{
            hidden: {
              opacity: 0,
              y: 30
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.6,
                ease: [0.22, 1, 0.36, 1]
              }
            }
          }} data-id="element-967">
              Verified climate impact
            </motion.span>
            <motion.span className="block text-carbon-deep mt-1" variants={{
            hidden: {
              opacity: 0,
              y: 30
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.6,
                ease: [0.22, 1, 0.36, 1]
              }
            }
          }} data-id="element-968">
              From Field Data
            </motion.span>
            <motion.span className="block text-carbon-deep mt-1" variants={{
            hidden: {
              opacity: 0,
              y: 30
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.6,
                ease: [0.22, 1, 0.36, 1]
              }
            }
          }} data-id="element-969">
              to Global Markets
            </motion.span>
          </motion.h1>

          <motion.p className="mt-8 text-lg sm:text-xl text-carbon-mid max-w-2xl mx-auto leading-relaxed" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.65,
          duration: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-970">
            Independent Carbon Accounting & dMRV-as-a-Service. Our mobile-first
            and enterprise-ready platforms generate audit-grade emissions data
            and compliance-ready reporting trusted by regulators, buyers, and
            investors.
          </motion.p>

          <motion.div className="mt-6 flex flex-wrap items-center justify-center gap-3" initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.78,
          duration: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-971">
            <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full border border-carbon-geo bg-white text-sm font-medium text-carbon-deep" data-id="element-972">
              <span className="w-2 h-2 rounded-full bg-carbon-bright" data-id="element-973" />
              EUDR Compliant
            </span>
            <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full border border-carbon-geo bg-white text-sm font-medium text-carbon-deep" data-id="element-974">
              <span className="w-2 h-2 rounded-full bg-carbon-bright" data-id="element-975" />
              UCDA Certified
            </span>
            <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full border border-carbon-geo bg-white text-sm font-medium text-carbon-deep" data-id="element-976">
              <span className="w-2 h-2 rounded-full bg-carbon-bright" data-id="element-977" />
              Independent dMRV
            </span>
          </motion.div>

          <motion.div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.85,
          duration: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-978">
            <a href="mailto:operations@carbonsafe.earth" className="inline-flex items-center gap-2.5 px-8 py-4 bg-carbon-bright text-white text-base font-semibold rounded-lg hover:bg-carbon-light transition-colors shadow-lg shadow-carbon-bright/20" data-id="element-979">
              Book Demo
              <ArrowUpRightIcon className="w-4.5 h-4.5" data-id="element-980" />
            </a>
            <a href="mailto:operations@carbonsafe.earth" className="inline-flex items-center gap-2.5 px-8 py-4 border-2 border-carbon-bright text-carbon-deep text-base font-semibold rounded-lg hover:bg-carbon-bright/5 transition-colors" data-id="element-981">
              Talk to Expert
              <ArrowUpRightIcon className="w-4.5 h-4.5" data-id="element-982" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}